<body>
  <ng-container *ngIf="loading_permissions; else app">
      <app-loading-app></app-loading-app>
</ng-container>

<ng-template #app>
  <router-outlet></router-outlet>
</ng-template>
</body>
